/* @jsxImportSource react */

import type { ReactNode } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';
import { Link } from '../Link/Link';

interface ProductCardV2NameProps {
  children: ReactNode;
  id: string;
  href: string;
  className?: string;
  onClick?: () => void;
}

export const ProductCardV2Name = ({
  children,
  id,
  href,
  className,
  onClick,
}: ProductCardV2NameProps) => (
  <Link
    id={`product-${id}-name`}
    aria-labelledby={`product-${id}-brand product-${id}-name`}
    href={href}
    className={cn(
      'product-card-name text-size-body2 text-color-text-dark decoration-color-grey-dark focus-visible:after:standard-focus-outline mx-2 mt-1 cursor-pointer [grid-area:3/2/span_1/span_1] after:absolute after:inset-[1px] after:z-10 after:content-normal after:rounded focus-visible:outline-none',
      className,
    )}
    onClick={onClick}
  >
    {children}
  </Link>
);
